module.exports = __webpack_public_path__ + "img/yatirimlar.bbacdfa6.png";